import React, { createContext, useState, useEffect } from 'react';
import { Link,useNavigate } from 'react-router-dom';
import { updateDownloadTrend } from '../utils/utils';
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        // Check if user is logged in on component mount
        const accessToken = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');
        if (accessToken && refreshToken) {
            setIsLoggedIn(true);
        }
    }, []);

    const handleLogin = (accessToken, refreshToken, author_or_not = false) => {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('author_or_not', author_or_not); 
        console.log(author_or_not)
        setIsLoggedIn(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('author_or_not'); 
        setIsLoggedIn(false);
        navigate('/login')

        
    };
    const backHomeClick=()=>{
        navigate('/home')
    }
    const updateTrends=(product)=>{
        const accessToken = localStorage.getItem("accessToken")
        updateDownloadTrend = updateDownloadTrend(accessToken, product.id)
    }
    return (
        <AuthContext.Provider value={{ isLoggedIn, handleLogin, handleLogout,backHomeClick,updateTrends }}>
            {children}
        </AuthContext.Provider>
    );
};

export { AuthContext, AuthProvider };
